export default __webpack_public_path__ + "static/media/wayfarerglasses.b03ff5f6.png";